import React from 'react';
import styled from 'astroturf/react';

import { Icon } from 'js/design_system/Icon';
import SearchBar from 'js/header/SearchBar/SearchBar';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';

import BareSearchField from './BareSearchField';

const CellRoot = styled.div<{ dividerTint: 'white' | 'beige' }>`
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  padding: 0 16px;

  &:hover {
    background: var(--background-light-blue, #eef2f9);
  }

  &.dividerTint-white {
    border-right: 1px solid var(--stroke-light, #dddde2);
  }

  &.dividerTint-beige {
    border-right: 1px solid var(--stroke-beige-light, #ccc9bc);
  }
`;

const CellWatcher = styled(ImpressionWatcher)`
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  align-items: center;
  column-gap: 8px;
`;

const SearchGlyph = styled(Icon)`
  flex: 0 0 auto;
  color: var(--text-primary, #141413);
`;

export type SearchCellProps = {
  initialQuery?: string;
  isPremium?: boolean;
  dividerTint: 'white' | 'beige';
};

const SearchCell = ({
  initialQuery,
  isPremium = false,
  dividerTint,
}: SearchCellProps) => (
  <CellRoot dividerTint={dividerTint} data-testid="search-cell">
    <CellWatcher source="focused_nav_search_bar">
      <SearchGlyph name="search" size={32} aria-hidden />
      <BareSearchField>
        <SearchBar
          initialQuery={initialQuery}
          isPremium={isPremium}
          placeholder="Search..."
          hideScopeSelector
        />
      </BareSearchField>
    </CellWatcher>
  </CellRoot>
);

export default SearchCell;
